import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import _ from "lodash";
import { Form, Segment,Message, Button, TextArea, Header } from "semantic-ui-react";
import FormErrorMessage from "../../utils/FormErrorMessage";
import {Link} from 'react-router-dom'
import { updateOrCreateInventory, updateInventoryModelInStore } from "../../../actions/inventory";
import Dls from "../../../lib";

class InventoryForm extends Component {
    constructor() {
        super();
        this.state = {
            errors: [],
            loading: false
        };
    }

    onFormSubmit = () => {
        const {id} = this.props.model;
        const action = this.props.model.id ? "Update" : "Create";
        const errors = this.validateInput();
        if (_.isEmpty(errors)) {
            this.setState({
                loading: true
            });
            this.props
                .updateOrCreateInventory(this.props.jwt, this.props.model)
                .then(res => {
                    if (action === 'Create') {
                        this.props.history.push(`/inventories/${res.data.data.id}/view`)
                    } else {
                        this.props.history.push(`/inventories/${id}/view`)
                    }
                })
                .catch(err => {
                    const errors = Dls.apiErrorMessage(err);
                    this.setState({
                        loading: false,
                        errors: errors
                    });
                });
        } else {
            this.setState({
                errors: errors
            });
        }
    };

    validateInput = () => {
        const { sku, name, cost, selling } = this.props.model;
        const errors = [];
        if (!sku) {
            errors.push("SKU is required");
        }
        if (!name) {
            errors.push("Name is required");
        }
        if (_.isNaN(parseFloat(cost))) {
            errors.push("Inventory cost must be a number");
        }
        if (_.isNaN(parseFloat(selling))) {
            errors.push("Inventory selling price must be a number");
        }
        return errors;
    };

    render() {
        const {model, updateInventoryModelInStore, isDirty} = this.props
        return (
            <Form size="mini">
                <Segment stacked>
                    {!_.isEmpty(this.state.errors) ? (
                        <FormErrorMessage errors={this.state.errors} />
                    ) : null}
                    <Header as='h3'>Inventory Information</Header>
                    <Form.Group unstackable widths={2}>
                        <Form.Input
                            fluid
                            label="Inventory SKU"
                            name="sku"
                            size='mini'
                            value={model.sku ? model.sku : ""}
                            onChange={(e) => { updateInventoryModelInStore(e.target.name, e.target.value) }}
                        />
                        <Form.Input
                            fluid
                            label="Inventory Name"
                            name="name"
                            size='mini'
                            value={model.name ? model.name : ""}
                            onChange={(e) => { updateInventoryModelInStore(e.target.name, e.target.value) }}
                        />
                    </Form.Group>
                    <Form.Group unstackable widths={2}>
                        <Form.Select fluid size='mini' label='Type' options={[
                                {key: 'Inventory', text: 'Inventory', value: 'Inventory'},
                                {key: 'Service', text: 'Service', value: 'Service'},
                                {key: 'Others', text: 'Others', value: 'Others'}
                            ]} name="type" value={model.type ? model.type : "Inventory"}
                            onChange={(e,data) => { updateInventoryModelInStore('type', data.value) }}
                        />
                        <Form.Select fluid size='mini' label='Status' options={[
                                {key: 'Active', text: 'Active', value: 'Active'},
                                {key: 'Disabled', text: 'Disabled', value: 'Disabled'}
                            ]} name="status" value={model.status ? model.status : "Active"}
                            onChange={(e,data) => { updateInventoryModelInStore('status', data.value) }}
                        />
                    </Form.Group>
                    <Form.Group unstackable widths={3}>
                        <Form.Input
                            fluid
                            label="Inventory UPC Code"
                            name="upc"
                            size='mini'
                            value={model.upc ? model.upc : ""}
                            onChange={(e) => { updateInventoryModelInStore(e.target.name, e.target.value) }}
                        />
                        <Form.Input
                            fluid
                            label="Purchase Cost Price"
                            name="cost"
                            size='mini'
                            value={model.cost ? model.cost : ""}
                            onChange={(e) => { updateInventoryModelInStore(e.target.name, e.target.value) }}
                        />
                        <Form.Input
                            fluid
                            label="Selling Price"
                            name="selling"
                            size='mini'
                            value={model.selling ? model.selling : ""}
                            onChange={(e) => { updateInventoryModelInStore(e.target.name, e.target.value) }}
                        />
                    </Form.Group>
                    <Form.Group unstackable widths={3}>
                        <Form.Input
                            fluid
                            label="Custom Field 1"
                            name="custom_1"
                            size='mini'
                            value={model.custom_1 ? model.custom_1 : ""}
                            onChange={(e) => { updateInventoryModelInStore(e.target.name, e.target.value) }}
                        />
                        <Form.Input
                            fluid
                            label="Custom Field 2"
                            name="custom_2"
                            size='mini'
                            value={model.custom_2 ? model.custom_2 : ""}
                            onChange={(e) => { updateInventoryModelInStore(e.target.name, e.target.value) }}
                        />
                        <Form.Input
                            fluid
                            label="Custom Field 3"
                            name="custom_3"
                            size='mini'
                            value={model.custom_3 ? model.custom_3 : ""}
                            onChange={(e) => { updateInventoryModelInStore(e.target.name, e.target.value) }}
                        />
                    </Form.Group>
                    <div style={{marginBottom: '5px'}}>
                        <label><strong>Inventory Description</strong></label>
                        <TextArea name="description"
                            value={model.description ? model.description: ""}
                            onChange={(e) => { updateInventoryModelInStore(e.target.name, e.target.value) }}
                        />
                    </div>

                    {model.spr ? <div> <Message info>
                                    This is a SPR item, looking to update Shopify information? Click <Link to={`/settings/ecommerce/products/${model.spr.id}/edit`}>here</Link>
                                </Message></div> : <div>
                                <Header as='h3'>
                                Shopify
                                <Header.Subheader>Do not enter or change Shopify ID and Shopify Variant ID unless you are 100% sure it's necessary</Header.Subheader>
                            </Header>
                            <Form.Group widths={2}>
                                <Form.Checkbox checked={model.is_shopify_item} onChange={() => {
                                    updateInventoryModelInStore('is_shopify_item', !model.is_shopify_item)
                                }} label="Sell This Inventory on Shopify"/>

                                <Form.Checkbox checked={model.should_update_shopify} onChange={() => {
                                    updateInventoryModelInStore('should_update_shopify', !model.should_update_shopify)
                                }} label="Queue This Invenotry For Update In Shopify"/>
                            </Form.Group>
                            <Form.Group unstackable widths={3}>
                                <Form.Input
                                    fluid
                                    label="Shopify ID (Admin)"
                                    name="shopify_id"
                                    size='mini'
                                    value={model.shopify_id ? model.shopify_id : ""}
                                    onChange={(e) => { updateInventoryModelInStore(e.target.name, e.target.value) }}
                                />
                                <Form.Input
                                    fluid
                                    label="Shopify Variant ID (Admin)"
                                    name="shopify_variant_id"
                                    size='mini'
                                    value={model.shopify_variant_id ? model.shopify_variant_id : ""}
                                    onChange={(e) => { updateInventoryModelInStore(e.target.name, e.target.value) }}
                                />
                                <Form.Input
                                    fluid
                                    label="Shopify Vendor"
                                    name="shopify_vendor"
                                    size='mini'
                                    value={model.shopify_vendor ? model.shopify_vendor : ""}
                                    onChange={(e) => { updateInventoryModelInStore(e.target.name, e.target.value) }}
                                />
                            </Form.Group>
                            <Form.Group unstackable widths={4}>
                                <Form.Input
                                    fluid
                                    label="Shopify Type"
                                    name="shopify_type"
                                    size='mini'
                                    value={model.shopify_type ? model.shopify_type : ""}
                                    onChange={(e) => { updateInventoryModelInStore(e.target.name, e.target.value) }}
                                />
                                <Form.Input
                                    fluid
                                    label="Shopify Tag 1 (Menu Tag)"
                                    name="category_1"
                                    size='mini'
                                    value={model.category_1 ? model.category_1 : ""}
                                    onChange={(e) => { updateInventoryModelInStore(e.target.name, e.target.value) }}
                                />
                                <Form.Input
                                    fluid
                                    label="Shopify Tag 2 (Second Level Tag)"
                                    name="category_2"
                                    size='mini'
                                    value={model.category_2 ? model.category_2 : ""}
                                    onChange={(e) => { updateInventoryModelInStore(e.target.name, e.target.value) }}
                                />
                                <Form.Input
                                    fluid
                                    label="Shopify Tag 3 (Third Level Tag)"
                                    name="category_3"
                                    size='mini'
                                    value={model.category_3 ? model.category_3 : ""}
                                    onChange={(e) => { updateInventoryModelInStore(e.target.name, e.target.value) }}
                                />
                                <Form.Input
                                    fluid
                                    label="Put Best Seller Here to Show in Home Page"
                                    name="category_4"
                                    size='mini'
                                    placeholder="Best Seller"
                                    value={model.category_4 ? model.category_4 : ""}
                                    onChange={(e) => { updateInventoryModelInStore(e.target.name, e.target.value) }}
                                />
                            </Form.Group>
                            <div style={{marginBottom: '10px'}}>
                                <label><strong>Shopify HTML Description</strong></label>
                                <TextArea name="html_description"
                                    value={model.html_description ? model.html_description: ""}
                                    rows={10}
                                    onChange={(e) => { updateInventoryModelInStore(e.target.name, e.target.value) }}
                                />
                            </div>
                    </div>}
                    <Button
                        color="teal"
                        onClick={this.onFormSubmit}
                        loading={this.state.loading}
                        disabled={!isDirty}
                        size='mini'
                    >
                        Save
                    </Button>
                </Segment>
            </Form>
        );
    }
}

InventoryForm.propTypes = {
    history: PropTypes.shape({
        push: PropTypes.func.isRequired
    }).isRequired,
    updateOrCreateInventory: PropTypes.func.isRequired,
    updateInventoryModelInStore: PropTypes.func.isRequired,
    model: PropTypes.object.isRequired,
    isDirty: PropTypes.bool.isRequired,
    jwt: PropTypes.string.isRequired
};

function mapStateToProps(state) {
    return {
        model: state.inventory.model,
        isDirty: state.inventory.dirty,
        jwt: state.auth.jwt
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            updateOrCreateInventory,
            updateInventoryModelInStore
        },
        dispatch
    );
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(InventoryForm);



// WEBPACK FOOTER //
// ./src/components/forms/inventories/Inventory.js